import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export default function TablePermissions({rows, columns, ...props}) {
  return (
    <Box sx={{ height: 500, width: '100%', mb: 1 }} {...props}>
      <DataGrid rows={rows} columns={columns} />
    </Box>
  );
}
